module.exports = __webpack_public_path__ + "static/icon_share.798db587.png";